import { DarkProvider } from '@hivewatch/dark'

import { DarkEditDeviceModal, useDeviceModals } from '@/features/device-crud'
import { MODAL_Z_INDEX } from '@/styles/theme'

import { DeviceConfigurationT } from '../types/types'
import { DevicesMisconfiguredModal } from './DevicesMisconfiguredModal'

interface MisconfiguredDoorsModalsIProps {
  devices: DeviceConfigurationT[]
  isOpen: boolean
  onClose: () => void
  /** Fired after a door edit saves, so callers can re-run their check. */
  onDoorSaved: () => void
}

/**
 * The View Doors flow shared by the legacy criteria section and the v2
 * on-demand door check: the misconfigured-doors list modal plus the elevated
 * dark Edit Device modal it opens. Owns the edit-modal state so callers only
 * control the list modal's disclosure.
 */
export const MisconfiguredDoorsModals = ({
  devices,
  isOpen,
  onClose,
  onDoorSaved,
}: MisconfiguredDoorsModalsIProps) => {
  const { openEditDevice, isEditDeviceOpen, onEditDeviceClose, deviceData } =
    useDeviceModals()

  return (
    <>
      <DevicesMisconfiguredModal
        devices={devices}
        isOpen={isOpen}
        onClose={onClose}
        onEditDevice={openEditDevice}
      />
      {isEditDeviceOpen && (
        <DarkProvider>
          {/* Above the misconfigured-doors modal (Chakra v1 modal z-index
              1400), which the dark Modal's 1000 default renders behind */}
          <DarkEditDeviceModal
            deviceData={deviceData}
            isOpen={isEditDeviceOpen}
            onClose={onEditDeviceClose}
            onSave={onDoorSaved}
            zIndex={MODAL_Z_INDEX}
          />
        </DarkProvider>
      )}
    </>
  )
}
